import { skipToken, useQuery } from "@tanstack/react-query";
import {
  getBankingBatchPaymentsPublicId,
  type BatchPaymentDetailDto,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const BATCH_PAYMENT_DETAIL_QUERY_KEY = "BATCH_PAYMENT_DETAIL";

export const batchPaymentDetailKeys = {
  all: [BATCH_PAYMENT_DETAIL_QUERY_KEY],
  byPublicId: (publicId?: string | null) => [
    ...batchPaymentDetailKeys.all,
    publicId,
  ],
};

type Props = {
  publicId?: string | null;
  enabled?: boolean;
};

export const useBatchPaymentDetail = ({ publicId, enabled = true }: Props) =>
  useQuery<BatchPaymentDetailDto>({
    queryKey: batchPaymentDetailKeys.byPublicId(publicId),
    queryFn: publicId
      ? processResponseWithApiProblemDetails(() =>
          getBankingBatchPaymentsPublicId(publicId),
        )
      : skipToken,
    enabled,
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      if (status === "Processing" || status === "Initiated") {
        return 5000;
      }
      return false;
    },
  });
